import React from 'react';
import T from 'prop-types';
import Modal, {
  OpenModalButton,
  ModalPanel,
  CloseModalButton,
} from '../../platformui/Modal';
import Chevron from '../icons/chevron';

const ToolTipModal = (props) => {
  return (
    <Modal>
      <div className="tooltip-modal__modal-container">
        <OpenModalButton className="c-formbutton c-formbutton--primary tooltip-modal__modal-open">
          {props.openText}
          <Chevron fillColor="#ffffff" className="tooltip-modal__chevron" />
        </OpenModalButton>
        <ModalPanel>
          <div className="tooltip-modal tooltip-modal__modal-panel">
            <div className="tooltip-modal__modal-panel__content tooltip-modal__header">
              {props.header && (
                <h3 className="tooltip-modal__heading">{props.header}</h3>
              )}
              <CloseModalButton className="tooltip-modal__modal-close">
                {props.closeText}
              </CloseModalButton>
            </div>
            <div className="tooltip-modal__modal-panel__content">
              {props.children}
            </div>
          </div>
        </ModalPanel>
      </div>
    </Modal>
  );
};

ToolTipModal.propTypes = {
  header: T.string,
  openText: T.string,
  closeText: T.string,
};

export default ToolTipModal;
